import { Tooltip as TooltipMaterial, withStyles } from '@material-ui/core';
import React from 'react';
var Tooltip = function (_a) {
    var className = _a.className, children = _a.children, title = _a.title;
    var CustomTooltip = withStyles(function () { return ({
        tooltip: {
            backgroundColor: 'var(--blanco)',
            color: 'var(--text1)',
            maxWidth: 220,
            fontSize: '0.625rem',
            boxShadow: 'var(--box-shadow)',
        },
        arrow: {
            color: 'var(--blanco)',
        },
    }); })(TooltipMaterial);
    return (React.createElement(CustomTooltip, { arrow: true, className: className, title: title }, children));
};
Tooltip.defaultProps = {
    className: '',
};
export default Tooltip;
